import SVGANIMATION from '../../../../DOM/svg/SVGOBJECT/SVGANIMATION.js';
import { SVGANIMATIONELEMENT } from '../../../../../enums/SVGANIMATIONELEMENT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
;
// Model Structure
export const svgAnimateAttr = makeAttrStruct([
    ['attributeName'],
    ['begin'],
    ['dur'],
    ['repeatCount'],
    ['from'],
    ['to']
]);
export const svgAnimateData = makeDataStruct([]);
export const svgAnimateModel = makeStruct([
    ['attributes', svgAnimateAttr],
    ['data', svgAnimateData]
]);
// Simplified Model
export function svgAnimate(attributeName, begin, dur, repeatCount, from, to) {
    return {
        attributes: svgAnimateAttr(attributeName, begin, dur, repeatCount, from, to),
        data: svgAnimateData()
    };
}
/** Creates an animation object for an SVG Shape */
export default class SVGANIMATE extends SVGANIMATION {
    constructor(node, model) {
        super(node, SVGANIMATIONELEMENT.ANIMATE, model);
    }
}
